import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAppointmentsStatisticsBlockRequest, getAppointmentsUsersListRequest } from '../../../store/appointments/actions';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { calendar } from '../../../utils/images';
import AddIcon from "@material-ui/icons/Add";
import CachedIcon from '@material-ui/icons/Cached';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import PriorityHighRoundedIcon from '@material-ui/icons/PriorityHighRounded';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from '@material-ui/core/Tooltip';
import { useHistory } from 'react-router-dom';

function SpecialistAppointments({ intl: { messages } }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const { appointmentsStatisticsBlock, usersList } = useSelector((state) => state.appointments);
    const [specialistList, setSpecialistList] = useState([]);
    const [userId, setUserId] = useState(0);
    //const [selectedDate, handleDateChange] = useState(moment().format('YYYY-MM-DD'));
    const [startDate, setStartDate] = useState(moment().subtract(7, "days").format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [query, setQuery] = useState('');

    useEffect(() => {
        dispatch(getAppointmentsStatisticsBlockRequest());
        dispatch(getAppointmentsUsersListRequest({ roleId: -2 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    // Users List
    useEffect(() => {
        if (usersList && usersList.length > 0) {
            let list = [];
            usersList.forEach((item) => {
                list.push({
                    id: item.id,
                    name: item.name,
                });
            });
            setSpecialistList(list);
        } else {
            setSpecialistList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersList])

    useEffect(() => {
        dispatch(getAppointmentsStatisticsBlockRequest({userId: userId, startDate: startDate, endDate: endDate}));
        setQuery(`&userId=${userId}&startDate=${startDate}&endDate=${endDate}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, startDate, endDate]);

    return (
        <div className='specialist_appointments'>
            <h3>{messages.appointments.specialistAppointments}</h3>
            <div className='specialist_appointments_selectbox'>
                <select value={userId} onChange={(e) => setUserId(e.target.value)}>
                    <option value={0}>{messages.appointments.allSpecialist_placeholder}</option>
                    {specialistList?.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                </select>
                <div className='dates-container'>
                    <div>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable
                                inputProps={{ 'placeholder': `${messages.shared.from}` }}
                                value={startDate}
                                onChange={date => date ? setStartDate(moment(date).format('YYYY-MM-DD')) : setStartDate(null)}
                                format="yyyy-MM-dd"
                                keyboardIcon={<img src={calendar} alt="calendar" width="15px" height="15px"/>}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable
                                inputProps={{ 'placeholder': `${messages.shared.to}` }}
                                value={endDate}
                                onChange={date => date ? setEndDate(moment(date).format('YYYY-MM-DD')) : setEndDate(null)}
                                format="yyyy-MM-dd"
                                keyboardIcon={<img src={calendar} alt="calendar" width="15px" height="15px"/>}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div className='icon-container'>
                        <Tooltip title={`${messages.appointments.refresh}`} placement="bottom" >
                            <div><RefreshIcon title='clear' onClick={() => {
                                setStartDate(null);
                                setEndDate(null);
                                setUserId(0);
                            }} /></div>
                        </Tooltip>
                    </div>
                    
                </div>
            </div>
            <div className='specialist_appointments_statistics'>
                <div className='specialist_appointments_statistics_item' 
                    onClick={() => history.push(`/appointmentStatistics?status=1${query}`)}>
                    <span className='icon-container'>
                        <span className='icon new'>
                            <AddIcon/>
                        </span>
                        {messages.appointments.statistics.newAppointment}
                    </span>
                    <span>{appointmentsStatisticsBlock?.new}</span>
                </div>
                <div className='specialist_appointments_statistics_item'
                    onClick={() => history.push(`/appointmentStatistics?status=-1${query}`)}>
                    <span className='icon-container'>
                        <span className='icon active'>
                            <CachedIcon/>
                        </span>
                        {messages.appointments.statistics.notCompletedAppointment}
                    </span>
                    <span>{appointmentsStatisticsBlock?.active}</span>
                </div>
                <div className='specialist_appointments_statistics_item'
                    onClick={() => history.push(`/appointmentStatistics?status=4${query}`)}>
                    <span className='icon-container'>
                        <span className='icon completed'>
                            <CheckIcon />
                        </span>
                        {messages.appointments.statistics.completedAppointment}
                    </span>
                    <span>{appointmentsStatisticsBlock?.completed}</span>
                </div>
                <div className='specialist_appointments_statistics_item'
                    onClick={() => history.push(`/appointmentStatistics?status=5${query}`)}>
                    <span className='icon-container'>
                        <span className='icon canceled'>
                        <ClearIcon />
                        </span>
                        {messages.appointments.statistics.cancelledAppointment}
                    </span>
                    <span>{appointmentsStatisticsBlock?.canceled}</span>
                </div>
                <div className='specialist_appointments_statistics_item'
                    onClick={() => history.push(`/appointmentStatistics?status=6${query}`)}>
                    <span className='icon-container'>
                        <span className='icon rejected'>
                        <PriorityHighRoundedIcon />
                        </span>
                        {messages.appointments.statistics.missedAppointment}
                    </span>
                <span>{appointmentsStatisticsBlock?.missed}</span>
                </div>
            </div>
        </div>
  )
}

export default injectIntl(SpecialistAppointments)